export default {
  handleDocumentContainer: {
    title: 'Ein Angebot anhängen',
    text: 'Legen Sie uns einen Kostenvoranschlag von einem Handwerker Ihrer Wahl vor. Dieser wird von unserer technischen Abteilung überprüft, die ihn bestätigt oder sich bei Bedarf mit Ihnen in Verbindung setzt.',
    actions: {
      primary: 'Weiter'
    },
    documentUploadStep: {
      actions: {
        primary: 'Dokument anhängen'
      }
    },
    icrModal: {
      title: 'Herunterladen von Dateien',
      text1: 'Die Dateien werden gerade verarbeitet. Bitte warten Sie weiter.',
      text2: 'Der Vorgang kann einige Minuten dauern.',
      text3: 'Wir verarbeiten Ihre Dokumente. Innerhalb weniger Minuten werden wir Ihre Entschädigung bestätigen.'
    }
  }
}
